import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {faStar, faSyncAlt} from '@fortawesome/free-solid-svg-icons';
import {Button, Table} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import moment from 'moment';
import {Link} from 'react-router-dom';
import numeral from 'numeral';
import * as renewalsService from '../../services/renewals';

import stylesLayout from '../../common/layout.module.scss';
import Loading from '../../components/Loading';

const PaymentsModule = ({selectedFleet}) => {
  const [loading, setLoading] = useState(false);
  const [renewals, setRenewals] = useState([]);

  const load = async (showLoading) => {
    if (showLoading) {
      setLoading(true);
    }
    const rsp = await renewalsService.find({
      fleet_id: selectedFleet.id,
    });

    if (rsp?.status) {
      setRenewals(rsp.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    load(true);
  }, [selectedFleet.id]);

  const renewalsColumns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      render: (id, r) => (
        <div className='flex flex-col gap-1'>
          <div>#{r.id}</div>
          <div className='text-xs'>
            {r.is_first ? 'Nueva suscripción' : 'Renovación'}
          </div>
        </div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status, r) => <div>{r.status_tr}</div>,
    },
    {
      title: 'Suscripción',
      dataIndex: 'subscription',
      key: 'subscription',
      render: (v, r) => (
        <div className='flex flex-col gap-1'>
          <Link to={`/suscripcion/${r.subscription.id}`}>
            #{r.subscription.id}
          </Link>
          <div className='text-xs'>
            {r.subscription.qty} {r.subscription.item_type}
          </div>
        </div>
      ),
    },
    {
      title: 'Usuario',
      dataIndex: ['subscription', 'user'],
      key: 'subscription_user',
      render: (v) => (
        <>
          <div>
            <Link to={`/cliente/${v.id}`}>
              #{v.id} - {v.name || '(Sin nombre)'}
            </Link>
          </div>
          <div>
            <small>{v.email}</small>
          </div>
        </>
      ),
    },
    {
      title: 'Monto',
      dataIndex: 'total',
      key: 'total',
      render: (v) => (
        <div>
          {selectedFleet.cost?.currency_symbol}
          {numeral(v).format(selectedFleet.cost?.currency_format)}
        </div>
      ),
    },
    {
      title: 'Fecha pago completado',
      dataIndex: 'payment_completed_at',
      key: 'payment_completed_at',
      render: (v) => (
        <div>{moment.utc(v).local().format('YYYY-MM-DD HH:mm:ss')}</div>
      ),
    },
    {
      title: 'Documentos',
      dataIndex: 'documents',
      key: 'documents',
      render: (v, r) => (
        <div>
          {r.data.receipts?.map((d) => (
            <div key={d.id}>
              {d.document.mimetype.startsWith('image') ? (
                <Link
                  to={`${d.document.private_url}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  {' '}
                  <img src={d.document.private_url} alt='' className='w-48' />
                </Link>
              ) : (
                <a
                  href={d.document.private_url}
                  target='_blank'
                  rel='noreferrer'
                >
                  Ver documento
                </a>
              )}
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <div className={`${stylesLayout.page}`}>
      <div className={stylesLayout.title}>
        <div>
          <div>Pagos ingresados recientemente</div>
          <div className='text-xs'>Últimos 50 pagos</div>
        </div>
        <div className={stylesLayout.secAction} style={{marginTop: -40}}>
          <Button
            onClick={() => {
              load(true);
            }}
            size='medium'
          >
            <FontAwesomeIcon icon={faSyncAlt} spin={loading} />
          </Button>
        </div>
      </div>
      <div className={stylesLayout.content}>
        {!loading ? (
          <div>
            <Table
              size='small'
              pagination={{hideOnSinglePage: true, defaultPageSize: 50}}
              locale={{emptyText: 'Sin datos'}}
              columns={renewalsColumns}
              dataSource={renewals.map((d) => ({
                key: d.id,
                ...d,
              }))}
            />
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

PaymentsModule.propTypes = {
  selectedFleet: PropTypes.object.isRequired,
};

export default PaymentsModule;
